import React, { CSSProperties } from 'react';
import cls from 'classnames';
import style from './Label.module.pcss';

export interface Props {
  bold?: boolean;
  className?: string;
  style?: CSSProperties;
  testId?: string;
}

const Label = (props: React.PropsWithChildren<Props>) => {
  return (
    <span
      className={cls(style.Label, props.className, {
        [style.bold]: props.bold,
      })}
      style={props.style}
      data-testid={props.testId}
    >
      {props.children}
    </span>
  );
};

export default Label;
